import Toastify from 'toastify-js';

export let Notify = {
    classes: {
        error: 'notify-error',
        success: 'notify-success',
        info: 'notify-info',
    },
    
    show(text, className = '') {
        Toastify({
            text: text,
            className: className === '' ? this.classes.info : className,
            position: 'center',
            stopOnFocus: false,
            close: false,
            onClick: function () { 
                document.querySelector('.toastify').remove();
            }
        }).showToast();
    },

    error(text) {
        this.show(text, this.classes.error);
    },

    success(text) {
        this.show(text, this.classes.success);
    },
}
